<div class="modal-overlay" *ngIf="employee">
    <div class="modal-container">
        <div class="modal-header">
            <h2>Krankmeldung erstellen - {{ employee.name }}</h2>
            <button class="close-button" aria-label="Schließen" (click)="onClose()">×</button>
        </div>

        <div class="modal-content">
            <!-- DATEV Authentication Required Message -->
            <div class="auth-required-message" *ngIf="!datevAuthService.getAuthStatus()()">
                <div class="warning-icon">⚠️</div>
                <h4>DATEV Authentifizierung erforderlich</h4>
                <p>Um Krankmeldungen zu erstellen, müssen Sie sich zuerst bei DATEV anmelden.</p>
                <button class="datev-login-button" (click)="loginDatev()">
                    Bei DATEV anmelden
                </button>
            </div>

            <!-- Employee Info and Form (only shown when authenticated) -->
            <div *ngIf="datevAuthService.getAuthStatus()()">

                <!-- Success Message -->
                <div class="message success-message" *ngIf="successMessage()">
                    <div class="message-icon">✓</div>
                    <div class="message-content">
                        <h4>Erfolgreich erstellt</h4>
                        <p>{{ successMessage() }}</p>
                    </div>
                </div>

                <!-- Error Message -->
                <div class="message error-message" *ngIf="errorMessage()">
                    <div class="message-icon">✕</div>
                    <div class="message-content">
                        <h4>Fehler beim Erstellen</h4>
                        <p>{{ errorMessage() }}</p>
                    </div>
                </div>

                <div class="employee-info">
                    <p><strong>Mitarbeiternummer:</strong> {{ employee.datevEmployeeNumber }}</p>
                    <p><strong>E-Mail:</strong> {{ employee.email }}</p>
                </div>

                <form [formGroup]="sickLeaveForm" (ngSubmit)="onSubmit()" *ngIf="!successMessage()">
                    <div class="form-field">
                        <label for="startDate">Beginn der Krankmeldung *</label>
                        <input
                                id="startDate"
                                type="date"
                                formControlName="startDate"
                                [class.ng-invalid]="sickLeaveForm.get('startDate')?.invalid && sickLeaveForm.get('startDate')?.touched"
                        >
                        <div class="error-message"
                             *ngIf="sickLeaveForm.get('startDate')?.invalid && sickLeaveForm.get('startDate')?.touched">
                            Bitte geben Sie ein Datum ein.
                        </div>
                    </div>

                    <div class="form-field">
                        <label for="endDate">Ende der Krankmeldung *</label>
                        <input
                                id="endDate"
                                type="date"
                                formControlName="endDate"
                                [class.ng-invalid]="sickLeaveForm.get('endDate')?.invalid && sickLeaveForm.get('endDate')?.touched"
                        >
                        <div class="error-message"
                             *ngIf="sickLeaveForm.get('endDate')?.hasError('required') && sickLeaveForm.get('endDate')?.touched">
                            Bitte geben Sie ein Enddatum ein.
                        </div>
                        <div class="error-message"
                             *ngIf="sickLeaveForm.get('endDate')?.hasError('invalidEndDate') && sickLeaveForm.get('endDate')?.touched">
                            Das Enddatum muss nach dem Startdatum liegen.
                        </div>
                    </div>

                    <div class="form-field checkbox-field">
                        <label>
                            <input
                                    type="checkbox"
                                    formControlName="isFollowUp"
                            >
                            Folgekrankmeldung
                        </label>
                    </div>

                    <div class="form-field checkbox-field">
                        <label>
                            <input
                                    type="checkbox"
                                    formControlName="mitAttest"
                            >
                            Mit Attest
                        </label>
                    </div>

                    <div class="button-group">
                        <button type="submit" [disabled]="sickLeaveForm.invalid || isSubmitting()">
                            {{ isSubmitting() ? 'Wird erstellt...' : 'Krankmeldung erstellen' }}
                        </button>
                        <button type="button" class="cancel-button" (click)="onClose()">Abbrechen</button>
                    </div>
                </form>

                <!-- Action buttons when success message is shown -->
                <div class="success-actions" *ngIf="successMessage()">
                    <button class="primary-button" (click)="onClose()">
                        Schließen
                    </button>
                </div>

            </div>
        </div>
    </div>
</div>
